import React, { useEffect, useCallback, useState } from 'react';
// import Link from 'next/link';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [user, setUser] = useState(null);

  const setUserCallback = useCallback((user) => {
    setUser(user);
  }, []);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUserCallback);

    return () => unsubscribe();
  }, [setUserCallback]);

  const logoutUser = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        console.log('logout ho gaya');
      })
      .catch((error) => {
        console.log('logout nhi hua');
        // An error happened.
      });
  };
  return (
    <nav className="animate__animated animate__fadeIn print:hidden flex flex-col md:flex-row md:justify-between md:px-10 gap-2 md:gap-0 md:items-center md:h-16 shadow-md bg-gradient-to-r from-indigo-300 to-gray-100 px-3 pb-2 md:pb-0">
      <div className="text-xl font-bold  ">
        <Link to="/">
          <h2 className="text-xl font-bold">The Directory Business Setup</h2>
        </Link>
      </div>
      {user ? (
        <div className=" flex gap-5 justify-between animate__animated animate__fadeIn">
          <p className="text-sm px-3 py-1 border border-black ">{user.email}</p>
          <button
            className="px-3 py-1 uppercase tracking-wider shadow-md hover:shadow-lg text-sm text-indigo-300 bg-black "
            onClick={logoutUser}
          >
            Logout
          </button>
        </div>
      ) : (
        // <div className="flex">
        //   <Link to="/login">
        //     <button className="px-3 py-1 uppercase tracking-wider shadow-md hover:shadow-lg text-sm text-black bg-indigo-300 rounded-lg">
        //       Login
        //     </button>
        //   </Link>
        // </div>
        null
      )}
    </nav>
  );
};

export default Navbar;
